<template>
  <div class="step-form">
    <h2 class="step-form__title">{{ $t('step1.title') }}</h2>
    <p class="step-form__subtitle">{{ $t('step1.subtitle') }}</p>

    <div class="step-form__grid">
      <div class="field">
        <label class="field__label">{{ $t('step1.firstName') }}</label>
        <input class="field__input" type="text" :value="formData.firstName"
               :placeholder="$t('step1.firstNamePlaceholder')"
               @input="emit('firstName', $event.target.value)" />
      </div>
      <div class="field">
        <label class="field__label">{{ $t('step1.lastName') }}</label>
        <input class="field__input" type="text" :value="formData.lastName"
               :placeholder="$t('step1.lastNamePlaceholder')"
               @input="emit('lastName', $event.target.value)" />
      </div>
      <div class="field">
        <label class="field__label">{{ $t('step1.phone') }}</label>
        <input class="field__input" type="tel" :value="formData.phone"
               :placeholder="$t('step1.phonePlaceholder')"
               @input="emit('phone', $event.target.value)" />
      </div>
      <div class="field">
        <label class="field__label">{{ $t('step1.email') }}</label>
        <input class="field__input" type="email" :value="formData.email"
               :placeholder="$t('step1.emailPlaceholder')"
               @input="emit('email', $event.target.value)" />
      </div>
      <div class="field">
        <label class="field__label">{{ $t('step1.company') }}</label>
        <input class="field__input" type="text" :value="formData.company"
               :placeholder="$t('step1.companyPlaceholder')"
               @input="emit('company', $event.target.value)" />
      </div>
      <div class="field">
        <label class="field__label">{{ $t('step1.position') }}</label>
        <input class="field__input" type="text" :value="formData.position"
               :placeholder="$t('step1.positionPlaceholder')"
               @input="emit('position', $event.target.value)" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonalInfo',
  props: { formData: Object },
  methods: {
    emit(field, value) {
      this.$emit('update', { [field]: value })
    },
  },
}
</script>

<style lang="scss" scoped>
.step-form {
  &__title {
    font-size: clamp(1.4rem, 3vw, 2rem);
    font-weight: 800;
    margin-bottom: 0.4rem;
    background: linear-gradient(135deg, #fff 30%, var(--gold-light));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  &__subtitle {
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.4);
    margin-bottom: 2rem;
  }

  &__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    @media (max-width: 600px) {
      grid-template-columns: 1fr;
    }
  }
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;

  &__label {
    font-size: 0.76rem;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.45);
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }

  &__input {
    padding: 14px 16px;
    border: 1.5px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.04);
    color: #fff;
    font-size: 0.92rem;
    transition: all 0.2s;
    outline: none;

    &::placeholder { color: rgba(255, 255, 255, 0.18); }

    &:focus {
      border-color: var(--gold);
      background: rgba(208, 176, 146, 0.06);
      box-shadow: 0 0 0 3px rgba(208, 176, 146, 0.1);
    }
  }
}
</style>
